import moment from 'moment-timezone'

export function companyTz() {
  return window.timezone_name || 'UTC'
}

export function companyTimeFormat() {
  return window.time_format === '24h' ? '24h' : '12h'
}

export function applyMomentTimezone(tz = companyTz()) {
  const zone = tz || 'UTC'
  if (moment.tz && typeof moment.tz.setDefault === 'function') {
    moment.tz.setDefault(zone)
  }
  return zone
}

export function parseApiInstant(value) {
  if (value === null || value === undefined || value === '') {
    return null
  }

  if (moment.isMoment(value)) {
    return value.clone().tz(companyTz())
  }

  const raw = String(value).trim()
  // Treat naive SQL timestamps as UTC (post-migration storage / ISO without Z).
  if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}/.test(raw) && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(raw)) {
    return moment.utc(raw.replace(' ', 'T')).tz(companyTz())
  }

  return moment.utc(raw).tz(companyTz())
}

/** Today's civil date in the company timezone as Y-m-d. */
export function companyTodayYmd() {
  return moment.tz(companyTz()).format('YYYY-MM-DD')
}

/** Format a civil Y-m-d (no timezone shift). */
export function formatCivilDate(ymd) {
  if (ymd === null || ymd === undefined || ymd === '') {
    return ''
  }
  const m = moment(String(ymd).slice(0, 10), 'YYYY-MM-DD', true)
  return m.isValid() ? m.format('MMM D, YYYY') : ''
}

export function formatCompanyDate(value) {
  // Bare Y-m-d is a civil calendar date, not a UTC midnight instant.
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
    return formatCivilDate(value)
  }
  const m = parseApiInstant(value)
  return m && m.isValid() ? m.format('MMM D, YYYY') : ''
}

export function formatCompanyDateTime(value) {
  const m = parseApiInstant(value)
  if (!m || !m.isValid()) {
    return ''
  }

  const timePart = companyTimeFormat() === '24h' ? m.format('HH:mm') : m.format('h:mm A')
  return `${m.format('MMM D, YYYY')}, ${timePart}`
}

export function formatCompanyTime(value) {
  const m = parseApiInstant(value)
  if (!m || !m.isValid()) {
    return ''
  }

  return companyTimeFormat() === '24h' ? m.format('HH:mm') : m.format('h:mm A')
}

/** Civil calendar date Y-m-d in company TZ (for datepickers / booking dates). */
export function civilDateToApi(ymd) {
  if (!ymd) {
    return null
  }
  return String(ymd).slice(0, 10)
}

/**
 * Civil Y-m-d params for API filters (backend converts using company TZ).
 */
export function apiRangeToUtcParams(dateFrom, dateTo) {
  const params = {}

  if (dateFrom) {
    params.date_from = String(dateFrom).slice(0, 10)
  }
  if (dateTo) {
    params.date_to = String(dateTo).slice(0, 10)
  }

  return params
}

export function toUtcIso(localValue) {
  if (!localValue) {
    return null
  }
  const m = moment.isMoment(localValue)
    ? localValue.clone()
    : moment.tz(localValue, companyTz())
  return m.utc().toISOString()
}

export { moment }
